module.exports = __webpack_public_path__ + "img/64.f4af10f3.jpg";